import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { scheduleQueryKeys } from "toptaal-shared"
import { fetchUserSchedule } from "@/api/services/schedule"
import { CalendarWithModal } from "@/components/modals/calendar/CalendarWithModal"

export const Route = createFileRoute("/beheer/medewerkers/$userId/agenda/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "employees"),
})

function RouteComponent() {
  const { userId } = useParams({ from: "/beheer/medewerkers/$userId" })

  return (
    <CalendarWithModal
      id={parseInt(userId)}
      getQueryKey={scheduleQueryKeys.user}
      queryFn={({ id, startDate, endDate }) =>
        fetchUserSchedule({ id, startDate, endDate })
      }
    />
  )
}
